import React from 'react';
import { useField } from 'formik';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';

export default function DatePickerField(props) {
  const { label, name, errorText, textFieldProps = {}, ...rest } = props;
  const [field, meta, helpers] = useField(name); // Using the `name` prop
  const { setValue } = helpers;

  // Ensure the value is converted to a Day.js object or null if invalid
  const fieldValue = field.value ? dayjs(field.value) : null;

  // Helper function to display validation errors
  function renderHelperText() {
    if (meta.touched && meta.error) {
      return meta.error;
    }
    return '';
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...field} // Pass Formik's field props
        {...rest}  // Pass any additional props
        value={fieldValue} // Controlled value
        onChange={(value) => {
          if (value) {
            setValue(value.format('YYYY-MM-DD'), true); // Update Formik value
          } else {
            setValue(null, true); // Handle clearing the field
          }
        }}
        format="MM/DD/YYYY"
        slots={{
          textField: TextField
        }}
        slotProps={{
          textField: {
            label: label,
            error: meta.touched && Boolean(meta.error),
            helperText: renderHelperText(),
            fullWidth: true,
            ...textFieldProps,
            inputProps: textFieldProps.inputProps,
          },


          popper: {
            disablePortal: true,
            sx: { zIndex: 1500 },
          },


        }}
      />
    </LocalizationProvider>
  );
}
